import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { FinalStepsQuestionnaireItem } from './questionnaire'

export const FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [FinalStepsQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION]:
    QuestionnaireAnswerType.STRING,
  [FinalStepsQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES]: QuestionnaireAnswerType.STRING
}
